module.exports = __webpack_public_path__ + "news-4a753f38/emptystate-871f3f7f1049c60915d6879f54cb9921.svg";